import {isMatch, get, toPath, findIndex, map} from 'lodash'

import type {WithId} from './types'

export const empty = {}
export const getId = (val: WithId) => val.id
export const now = (): number => performance.now()
export const getPath = (state: any, dotPath: string) =>
  get(state, toPath(dotPath), empty)
export const not = (val: any) => !val
export const identity = (val: any) => val

// should be in high res -> state : S, action : A
export const flattenPayload =
  (f: (state: any, payload: any) => any) =>
  (state: any, {payload}: any) =>
    f(state, payload)

export const isGenerator = (fn: any) =>
  !!fn && !!fn.constructor && fn.constructor.name === 'GeneratorFunction'

export const isFork = (object: any) =>
  isMatch(object, {'@@redux-saga/IO': true, FORK: {}})

export const acceptValOrFunc =
  (wrappedFunction: Function) =>
  (resolverOrValue: any | Function) =>
  (payload: any) => {
    const value =
      resolverOrValue instanceof Function
        ? resolverOrValue(payload)
        : resolverOrValue

    return wrappedFunction(value)
  }

export const getIndex = <U extends any>(
  where: Array<U>,
  what: WithId
  // @ts-ignore
) => findIndex(where, (n) => getId(n) === getId(what))

export const filterOut = <U extends any>(
  where: Array<U>,
  what: WithId
  // @ts-ignore
) => [...where].filter((n) => getId(n) !== getId(what))

export const override = (a: any, b: any) => ({...a, ...b})
export const updateIfNeeded = (a: WithId, b: WithId) =>
  getId(a) === getId(b || {}) ? override(a, b) : a

export const findAndOverride = (where: Array<any>, what: WithId) => {
  const position = getIndex(where, what)
  return map(where, (element: WithId, idx: number) =>
    idx === position ? override(element, what) : element
  )
}
